import React from "react";
import ImagesSection from "./ImageSection";
import Tables from "../Tables/Tables";
import Chart from "../Chart/chart";
import TextSection from "./TextSection";
import "./All.css";
class TabSection extends React.Component {
  render() {
    let countryName = this.props.countryName;
    function parseSectionContent(key, val) {
      // debugger;
      let sectionContent;
      if (typeof val === "object") {
        if (val.hasOwnProperty("format")) {
          if (val.format === "image") {
            sectionContent = (
              <ImagesSection
                title={key}
                url={val.url}
                countryName={countryName}
                key={Math.random()}
              />
            );
          } else if (val.format === "table") {
            sectionContent = (
              <Tables title={key} module={val.data} key={Math.random()} />
            );
          } else if (val.format === "chart") {
            sectionContent = (
              <Chart title={key} module={val.data} key={Math.random()} />
            );
          }
        } else {
          // If object doesn't has format key
          // console.log(val);
          // parseTabContent(key, val);
          // let string = JSON.stringify(val);
          sectionContent = (
            <TabSection title={key} text={val} key={Math.random()} />
          );
        }
        // If val NOT object
      } /*  if (typeof val == "string") */ else {
        sectionContent = (
          <TextSection title={key} text={val} key={Math.random()} />
        );
      }

      return sectionContent;
    }
    let levelOb = this.props.text;
    // console.log("levelOb --> ", levelOb);

    let levelKeys = Object.keys(levelOb);
    // let sectionKey = this.props.title;
    let content = [];
    levelKeys.forEach(function (key, i) {
      content.push(parseSectionContent(key, levelOb[key]));
    });
    //Check if props.title is null, then don't show the bold title
    return (
      <div>
        <strong>{this.props.title}</strong>
        <div style={{paddingLeft: "10px"}}>{content}</div>
      </div>
    );
  }
}

export default TabSection;
